import { useCallback, useState } from "react";
import { toast } from "react-hot-toast";
import { api, FeatureRequestItem } from "./api";

/**
 * Optimistic upvote toggle shared by every view. `apply` patches the
 * caller's own state with the new count; on failure it's rolled back.
 */
export function useVoteToggle(apply: (id: string, patch: Pick<FeatureRequestItem, "vote_count" | "hasVoted">) => void) {
  const [votingId, setVotingId] = useState<string | null>(null);
  const toggle = useCallback(
    async (item: FeatureRequestItem) => {
      const before = { vote_count: item.vote_count, hasVoted: item.hasVoted };
      apply(item.id, { vote_count: item.vote_count + (item.hasVoted ? -1 : 1), hasVoted: !item.hasVoted });
      setVotingId(item.id);
      try {
        const r = await api.toggleVote(item);
        apply(item.id, { vote_count: r.voteCount, hasVoted: r.hasVoted });
      } catch (e: any) {
        apply(item.id, before);
        toast.error(e?.response?.data?.error || "Could not save your vote");
      } finally {
        setVotingId(null);
      }
    },
    [apply]
  );
  return { toggle, votingId };
}
